import React, { FC } from 'react';
import { ReactComponent as ScheduledIcon } from 'src/assets/images/scheduled-icon.svg';
import styled from 'styled-components';
import { IScheduleLine } from '../../graphql/types';
import { Black2, Grey, White1 } from '../../styles/colours';
import { Medium } from '../../styles/fonts';
import { FormattedDate } from '../formatted-date/formatted-date';
import { Quantity } from '../quantity/quantity';

const StyledScheduleLine = styled.div`
  display: flex;
  flex-direction: row;

  background: ${White1};

  margin-bottom: 0.25rem;
`;

const HeadCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;

  min-width: 10rem;
  padding: 0.5rem;

  font-family: ${Medium};
  margin: 1rem;

  border-right: 0.5px solid ${Grey};
`;

const BodyCell = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  padding: 0.5rem;
`;

const DataCell = styled.div`
  display: flex;
  flex-direction: column;

  padding: 0.5rem;

  min-width: 10rem;

  &:last-child {
    flex: 1;
  }
`;

const DataLabel = styled.div`
  color: ${Black2};
  font-size: 1rem;
`;

const DataValue = styled.div`
  font-family: ${Medium};
  font-size: 1.2rem;
  padding: 0.5rem 0;
`;

export const ScheduleData: FC<{ schedule: IScheduleLine }> = ({ schedule }) => {
  return (
    <StyledScheduleLine data-type="schedule">
      <HeadCell>
        <ScheduledIcon />
      </HeadCell>

      <BodyCell>
        <DataCell>
          <DataLabel>Quantity:</DataLabel>
          <DataValue data-type="scheduled-confirmed-quantity">
            <Quantity
              quantity={schedule.confirmedQuantity}
              unitOfMeasure={schedule.unitOfMeasure}
            />
          </DataValue>
        </DataCell>

        <DataCell>
          <DataLabel>Promise Date:</DataLabel>
          <DataValue data-type="scheduled-promise-date">
            <FormattedDate date={schedule.promiseDate} />
          </DataValue>
        </DataCell>
      </BodyCell>
    </StyledScheduleLine>
  );
};
